module.exports = __webpack_public_path__ + "media/fonts/gotham-bold-webfont-23b9f8cfcecf6b2a3785255be58a72fb.woff2";